import React from 'react';
import ReactCardFlip from 'react-card-flip';
import { VolumeCapsuleChart } from 'widgets/liquiditySummary/volumeCapsule/components/chart/VolumeCapsuleChart';
import { VolumeCapsuleValues } from 'widgets/liquiditySummary/volumeCapsule/components/values/VolumeCapsuleValues';
import { VolumeCapsuleData } from 'widgets/liquiditySummary/volumeCapsule/components/volumeCapsuleData';
import { VolumeCapsuleConfigState } from 'widgets/liquiditySummary/volumeCapsule/state/config/VolumeCapsuleConfigState';

export interface VolumeCapsuleContentProps {
    chartData: VolumeCapsuleData;
    config: VolumeCapsuleConfigState;
    dispatchConfigChanged: (
        configDelta: Partial<VolumeCapsuleConfigState>
    ) => void;
}

export function VolumeCapsuleContent(props: VolumeCapsuleContentProps) {
    const { chartData, config, dispatchConfigChanged } = props;

    const { view } = config;
    const isFlipped = view === 'values';

    const flip = () => {
        const nextView = isFlipped ? 'chart' : 'values';
        dispatchConfigChanged({ view: nextView });
    };

    if (!chartData.haveData) {
        return <></>;
    }

    return (
        <div className="VolumeCapsuleChartContent" onClick={flip}>
            <ReactCardFlip isFlipped={isFlipped} flipDirection={'vertical'}>
                <VolumeCapsuleChart key="front" chartData={chartData} />
                <VolumeCapsuleValues key="back" chartData={chartData} />
            </ReactCardFlip>
        </div>
    );
}
